<template>
    <van-overlay :show="show" :z-index="100">
        <div class="info">
            <div class="info-box">
                <h4>提示</h4>
                <div class="content">尊敬的教练，您还未完善教练信息，无法进行分享操作，请完善信息后再次点击分享按钮进行分享操作。</div>
                <input v-model="name" type="text" placeholder="请输入您的姓名">
                <van-button class="custom-btn" color="#00CA84" round block @click="handleSave">保存</van-button>
            </div>
            <div class="info-close">
                <img src="@/assets/vipCoach/v2/icon_gb.png" @click="hide">
            </div>
        </div>
    </van-overlay>
</template>
<script>
import { Overlay, Button, Toast } from 'vant'
import { bindAppFn } from '../../utils'

export default {
    name: 'vipCoachEditInfo',
    components: {
        [Overlay.name]: Overlay,
        [Button.name]: Button
    },
    data () {
        return {
            show: false,
            name: ''
        }
    },
    methods: {
        hide () {
            this.show = false
            setTimeout(() => {
                this.$emit('cancel')
            }, 300)
        },
        handleSave () {
            if (this.name) {
                Toast.loading({ duration: 0, forbidClick: true })
                this.$api.saveCoachUserInfo({
                    userName: this.name
                }).then(res => {
                    Toast.clear()
                    if (res.status) {
                        // 通知APP已完成姓名变更
                        bindAppFn({
                            name: 'app',
                            data: {
                                method: 'changeUserName',
                                params: {
                                    userName: this.name
                                }
                            }
                        })
                        this.hide()
                    } else {
                        Toast.fail({ message: res.message })
                    }
                })
            } else {
                Toast.fail({ message: '姓名不能为空' })
            }
        }
    },
    mounted () {
        this.show = true
    }
}
</script>
<style lang="scss" scoped>
*{
    box-sizing: border-box;
}
.info{
    position: fixed;
    top: 50%;
    left: 50%;
    width: 300px;
    transform: translate(-50%, -50%);
    color:#333;
    &-box{
        padding: 20px;
        border-radius: 10px;
        background-color: #fff;
        h4 {
            font-size: 18px;
            text-align: center;
        }
        .content{
            margin-top: 26px;
            font-size: 15px;
            line-height: 24px;
            text-align: center;
        }
        input{
            margin-top: 20px;
            width: 100%;
            font-size: 15px;
            padding: 14px 11px;
            border:1px solid #ccc;
            border-radius: 5px;
        }
        .custom-btn{
            margin-top: 20px;
            font-size: 17px;
            height: 43px;
        }
    }
    &-close{
        text-align: center;
        margin-top: 30px;
        img{
            width: 35px;
        }
    }
}
</style>
